import React, { useState } from "react";
import ModalChuyenNhapRutQuy from "../ModalChuyenNhapRutQuy";

const BtnNhapQuy = ({ onReload, RoleQuyTienMatDuyetQuy }) => {
    const [show, setShow] = useState(false);

    return (
        <>
           <a type="button" onClick={() => setShow(true)} style={{fontSize: 15}} className="btn">
                <span>
                    <img
                        src="/app-assets/images/icon-nhap-quy.png"
                        style={{  marginRight: '6px' }}
                        alt="Nhập quỹ"
                    />
                    Nhập quỹ
                </span>
            </a>
            
            {show && (
                <ModalChuyenNhapRutQuy
                    show={show}
                    onHide={() => setShow(false)}
                    mode={{ type: 51 }} // Type 51: Nhập quỹ
                    onSuccess={() => { setShow(false); if (onReload) onReload(); }}
                    RoleQuyTienMatDuyetQuy={RoleQuyTienMatDuyetQuy}
                />
            )}
        </>
    );
};
export default BtnNhapQuy;